
import { initCustomCheckboxes } from '../common'

/**
 * Calendar
 */
class Calendar {
    constructor(texts) {
        var that = this;
        this.container = null;
        this.buttons = {
            '1': null,
            '2': null,
            '3': null
        };
        this.filters = {
            '1': false,
            '2': false,
            '3': false
        };
        this.buttonsContainer = null;

        this.locked = false;
        this.date = null;
        this.events = {};

        this.calendarEventShown = false;
        this.lastClickedEventID = '';

        this.texts = texts;

        this.container = $("#calendar-content");

        this.buttonsContainer = $(".calendar-rsvp-buttons");
        initCustomCheckboxes(this.buttonsContainer);
        this.buttonsContainer.disableSelection();

        this.date = new Date();

        this.buttons['1'] = $(".calendar-filter-rsvp-1");
        this.buttons['2'] = $(".calendar-filter-rsvp-2");
        this.buttons['3'] = $(".calendar-filter-rsvp-3");

        this.buttons['1'].change(function() {that.filter(1, $(this).prop("checked") ? true : false);});
        this.buttons['2'].change(function() {that.filter(2, $(this).prop("checked") ? true : false);});
        this.buttons['3'].change(function() {that.filter(3, $(this).prop("checked") ? true : false);});

        if (this.buttons['1'].prop("checked")) this.filters['1'] = true;
        if (this.buttons['2'].prop("checked")) this.filters['2'] = true;
        if (this.buttons['3'].prop("checked")) this.filters['3'] = true;

    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    loadEvents(year, month) {
        var that = this
        that._lock()
        $.ajax({
            url: "/calendar/get-events/", dataType: 'json', type: 'post',
            data: {year: year, month: month},
            success(data) {
                if (data && data.success != undefined && data.success) {
                    that.container.html(data.view);
                    that.events = data.events;

                    that.initCalendarEvents();
                    // that.container.disableSelection();

                    that._unlock();

                    var now = new Date();
                    var y = that.date.getYear();

                    document.location.hash = ("20" + ((y - 100 < 10) ? "0" + (y - 100) : (y - 100))) + "-" + (that.date.getMonth() + 1);

                    var link = $('link[rel=icon]').remove().prop("href");
                    $('<link href="'+ link +'" rel="icon" type="image/png" />').appendTo('head');

                    that.initEventsTooltip();
                    that._filter();
                } else {
                    that._unlock();
                }
            }
        });
    }

    autoLoad() {
        var hash = null;
        if (window.location.hash) {
            hash = window.location.hash.replace("#", "");
            var tmp = hash.split("-");
            if (tmp.length == 2) {
                var tmpy = parseInt(tmp[0]);
                var tmpm = parseInt(tmp[1]);
                if (tmpy >= 2000 && tmpy < 2100 && tmpm >= 1 && tmpm <= 12) {
                    this.date = new Date(tmpy, tmpm - 1, 1, 1, 1, 1, 1);
                }
            }
        }

        var y = this.date.getYear();
        y = "20" + ((y - 100 < 10) ? "0" + (y - 100) : (y - 100));
        var m = this.date.getMonth() + 1;

        this.loadEvents(y, m);
    }

    loadPrevious() {
        var y = this.date.getYear();
        y = parseInt("20" + ((y - 100 < 10) ? "0" + (y - 100) : (y - 100)));
        var m = this.date.getMonth();

        m --;
        if (m < 0) {
            m = 11;
            y --;
        }

        this.date = new Date(y, m, 1, 1, 1, 1, 1);
        y = this.date.getYear();
        y = "20" + ((y - 100 < 10) ? "0" + (y - 100) : (y - 100));
        m = this.date.getMonth() + 1;

        this.calendarEventShown = false;
        this.loadEvents(y, m);
    }

    loadNext() {
        var y = this.date.getYear();
        y = parseInt("20" + ((y - 100 < 10) ? "0" + (y - 100) : (y - 100)));
        var m = this.date.getMonth();

        m ++;
        if (m >= 12) {
            m = 0;
            y ++;
        }

        this.date = new Date(y, m, 1, 1, 1, 1, 1);
        y = this.date.getYear();
        y = "20" + ((y - 100 < 10) ? "0" + (y - 100) : (y - 100));
        m = this.date.getMonth() + 1;

        this.calendarEventShown = false;
        this.loadEvents(y, m);
    }

    _handleNoEvents() {
        var res = $("#upcoming-events div[class^='rsvp-entry-']");
        var cnt = res.length;
        res.each(function(k, v) {
            if ($(v).is(":hidden")) {
                cnt --;
            }
        });

        if (cnt <= 0) {
            $("#no-events").css("display", "block");
        } else {
            $("#no-events").css("display", "none");
        }
    }

    _handleNoPastEvents() {
        var res = $("#past-events div[class^='rsvp-entry-']");
        var cnt = res.length;
        res.each(function(k, v) {
            if ($(v).is(":hidden")) {
                cnt --;
            }
        });

        if (cnt <= 0) {
            $("#no-past-events").css("display", "block");
        } else {
            $("#no-past-events").css("display", "none");
        }
    }

    _filter() {
        for (let k in this.filters) {
            if(this.filters[k]){
                $(".rsvp-entry-" + k).show();
            }else{
                $(".rsvp-entry-" + k).hide();
            }
        }
        this._handleNoEvents();
        this._handleNoPastEvents();
    }

    filter(status, on) {
        this.filters[status.toString()] = on ? true : false;
        this._filter();
    }

    rsvp(eventId, status) {
        if(status == 4){
            if(!window.confirm("This action will remove the event from your calendar. Are you sure?")){
                return;
            }
        }
        var that = this;
        this._lock();

        $.ajax({
            url: "/event/change-rsvp/", dataType: 'json', type: 'post',
            data: {id: eventId, status: status},
            success(data) {
                if (data && data.success != undefined && data.success) {
                    $("#event-" + eventId + " .rsvp-marker").each(function(k, v) {
                        if (!$(v).hasClass("disabled")) $(v).addClass("disabled");
                    });

                    if (that.events[eventId] != undefined) {
                        that.events[eventId]['rsvp'] = parseInt(status);
                        that.events[eventId]['rsvpText'] = data.rsvpText;
                    }

                    if (parseInt(that.lastClickedEventID) == parseInt(eventId)) {
                        if (parseInt(status) == 1) {
                            $('#calendar-event').find('div').removeClass().addClass('marker-green').text(data.rsvpText);
                        } else if (parseInt(status) == 2) {
                            $('#calendar-event').find('div').removeClass().addClass('marker-yellow').text(data.rsvpText);
                        } else if (parseInt(status) == 3) {
                            $('#calendar-event').find('div').removeClass().addClass('marker-pink').text(data.rsvpText);
                        } else if (parseInt(status) == 4) {
                            $('#calendar-event').find('div').removeClass().addClass('marker-blue').text(data.rsvpText);
                        }
                    }

                    if (parseInt(status) == 4) {
                        $("#event-" + eventId).remove();
                        $("#calendar-event-" + eventId).remove();
                        if (that.events[eventId] != undefined) delete that.events[eventId];
                    } else {
                        $("#event-" + eventId).removeClass().addClass('event rsvp-entry-' + status + " row mb-5");
                        if ($("#event-" + eventId + " .rsvp-" + status).hasClass('disabled')) {
                            $("#event-" + eventId + " .rsvp-" + status).removeClass('disabled');
                        }

                        $("#calendar-event-" + eventId).removeClass().addClass('event rsvp-entry-' + status);
                        if (status == 1) $("#calendar-event-" + eventId).addClass('marker-green');
                        else if (status == 2) $("#calendar-event-" + eventId).addClass('marker-yellow');
                        else if (status == 3) $("#calendar-event-" + eventId).addClass('marker-pink');
                        else if (status == 4) $("#calendar-event-" + eventId).addClass('marker-blue');
                    }

                    that._unlock();
                    that._filter();
                } else {
                    that._unlock();
                }
            }
        });
    }

    createEventTooltip(button) {
        var that = this;
        var eventTooltipContent;
        if(this.eventTooltip) {
            this.removeEventTooltip();
        }

        this.eventTooltipButton = button;
        this.eventTooltipButton.parent().addClass('selected');
        eventTooltipContent  = '<div class="calendar-events-tooltip events-list-horizontal">';
        eventTooltipContent += '<div class="event-info" id="calendar-event">'
        eventTooltipContent += $('#calendar-event').html();
        eventTooltipContent += '</div>';
        eventTooltipContent += '</div>';

        this.eventTooltip = $(eventTooltipContent).appendTo(that.eventTooltipButton.parent());

        $(document).bind('click', function(e) {
            var target = e.target;

            if(that.eventTooltip && target != that.eventTooltip[0] && !$(target).parents('.calendar-events-tooltip').length) {
                that.removeEventTooltip();
                $(document).unbind('click');
            }
        });
    }

    removeEventTooltip() {
        if(this.eventTooltip) {
            this.eventTooltipButton.parent().removeClass('selected');
            this.eventTooltipButton = null;

            this.eventTooltip.remove();
            this.eventTooltip = null;
        }
    }

    initCalendarEvents () {
        var that = this;

        $('#calendar-cal > table').find('a').click(function() {
            if(that.calendarEventShown && that.lastClickedEventID == $(this).data('id')) {
                that.closeEventInfo($(this));
            } else {
                that.updateCalendarEventInfo($(this).data('id'));

                if (!that.calendarEventShown) {
                    $(this).addClass('active');
                    if(window.innerWidth >= 576){
                        $('#calendar-cal').removeClass("col-12").addClass('compact col-8')//.css('width', '460px');
                    }else{
                        $('#calendar-cal').removeClass("col-12").addClass('compact col-1 overflow-hidden opacity-0')//.css('width', '460px');
                    }
                    // $('#calendar-event').parent().css({ left: '500px', width: '230px' });
                    $('#calendar-event').parent().show();
                } else {
                    $('#calendar-cal > table').find('a[data-id="' + that.lastClickedEventID + '"]').removeClass('active');
                    $(this).addClass('active');
                    $('#calendar-event').fadeOut(0).fadeIn(400);
                }

                that.calendarEventShown = true;
                that.lastClickedEventID = $(this).data('id');
            }

            that.removeTooltip();
            return false;
        });

        $('#calendar-event').find('a.close').unbind('click').bind('click', function() {
            that.closeEventInfo();
            return false;
        });
    }

    updateCalendarEventInfo(id) {
        var info = $('#calendar-event');
        if (this.events[id] != undefined && this.events[id]) {
            event = this.events[id];

            info.find('a.mask').prop('href', event.url);
            info.find('img').prop('src', event.imageUrl);
            info.find('time').text(event.dayOfWeek + ' · ' + event.dayOfMonth + ' ' + event.monthName);
            info.find('a.title').prop('href', event.url).text(event.name);
            info.find('td:eq(1)').find('a').prop('href', '/events/' + event.categoryKey + '/').text(event.categoryName);

            if (event.place && event.place !== 'null') info.find('td:eq(3)').text(event.place);
            if (event.cityName && event.countryName && event.cityName !== 'null' && event.countryName !== 'null') info.find('td:eq(3)').text(event.cityName + ', ' + event.countryName);
            if (event.price != undefined && event.price) info.find('td:eq(5)').text(event.price);

            if (parseInt(event.rsvp) == 1) {
                info.find('div').removeClass().addClass('marker-green').text(event.rsvpText);
            } else if (parseInt(event.rsvp) == 2) {
                info.find('div').removeClass().addClass('marker-yellow').text(event.rsvpText);
            } else if (parseInt(event.rsvp) == 3) {
                info.find('div').removeClass().addClass('marker-pink').text(event.rsvpText);
            }
        }
    }
    // 
    closeEventInfo(entry) {
        if(entry) {
            entry.removeClass('active');
        }
        else {
            $('#calendar-cal > table').find('a').removeClass('active');
        }

        $('#calendar-cal').removeClass('compact').removeClass("col-8").addClass("col-12")//.css('width', '690px');

        if(window.innerWidth >= 576){
            $('#calendar-cal').removeClass('compact').removeClass("col-8").addClass("col-12")//.css('width', '690px');
        }else{
            $('#calendar-cal').removeClass('compact').removeClass("col-1").removeClass("overflow-hidden").removeClass("opacity-0").addClass("col-12")//.css('width', '690px');
        }
        // $('#calendar-event').parent().css({ left: '730px', width: '0px' });
        $('#calendar-event').parent().hide();


        this.calendarEventShown = false;
        this.lastClickedEventID = null;
    }

    initEventsTooltip() {
        var that = this;
        var cells = $('#calendar-cal').find('table').find('tbody').find('td[data-tooltip=true]').find('.cell');

        cells.append('<div class="featured"></div>');

        cells.mouseover(function() {
            if(!$(this).find('a.event:visible').length) {
                $(this).addClass('empty');
            }
            else {
                $(this).removeClass('empty');
            }
        });

        cells.find('div.featured').click(function() {
            that.createTooltip($(this));
            return false;
        });
    }

    createTooltip(button) {
        var that = this;
        var tooltipContent;

        var date = button.parent().data('date').split('-');
        var day = date[0];
        var month = date[1];
        var year = date[2];
        var dateObj = new Date(month + '/' + day + '/' + year);
        var dayOfWeek = dateObj.getDay() - 1;
        if (dayOfWeek < 0) dayOfWeek = 6;

        if(this.tooltip) {
            if(this.tooltipButton[0] == button[0]) {
                this.removeTooltip();
                return;
            }
            else {
                this.removeTooltip();
            }
        }

        this.tooltipButton = button;
        this.tooltipButton.parent().addClass('selected');

        tooltipContent  = '<div class="calendar-events-tooltip">';
        tooltipContent += '<h2>' + this.texts.weekdays[dayOfWeek] + ', ' + this.texts.months[month - 1] + ' ' + day + '</h2>';
        tooltipContent += '<ul><li class="loading"></li></ul>';
        tooltipContent += '</div>';

        this.tooltip = $(tooltipContent).appendTo(that.tooltipButton.parent());

        $.ajax({
            url: '/calendar/get-featured/' + year + '/' + month + '/' + day + '/',
            dataType: 'json',
            type: 'post',

            success(data) {
                if(data) {
                    if(data.events.length) {
                        that.tooltip.find('ul').html('');

                        for(var i in data.events) {
                            tooltipContent  = '<li>';
                            tooltipContent += (data.events[i].id) ? '<a href="' + data.events[i].url + '" onmousedown="if(event.which <= 2) tracking.featuredClick(\'event\', ' + data.events[i].id + ', \'calendar_daily\');" target="_blank">' : '<a href="' + data.events[i].url + '" target="_blank">';
                            tooltipContent += '<img alt="" src="' + data.events[i].img + '" />';
                            tooltipContent += '<strong>' + data.events[i].name + '</strong>';
                            tooltipContent += '<span>' + data.events[i].location + '</span>';
                            tooltipContent += '</a>';
                            tooltipContent += '</li>';

                            that.tooltip.find('ul').append($(tooltipContent));
                        }
                    }
                    else {
                        that.tooltip.find('ul').html('<li class="message">' + that.texts.noRecommendations + '</li>');
                    }
                }
            }
        });

        $(document).bind('click', function(e) {
            var target = e.target;

            if(that.tooltip && target != that.tooltip[0] && !$(target).parents('.calendar-events-tooltip').length) {
                that.removeTooltip();
                $(document).unbind('click');
            }
        });
    }

    removeTooltip() {
        if(this.tooltip) {
            this.tooltipButton.parent().removeClass('selected');
            this.tooltipButton = null;

            this.tooltip.remove();
            this.tooltip = null;
        }
    }
}

export { Calendar }